import { SvgDelete, SvgEdit } from '@ui-kit'
import { ViewOptionComponentProps } from '../../types/userPreferences.types'

const TableViewOptionBox = ({
  option,
  handleEdit,
  handleDelete,
}: ViewOptionComponentProps) => {
  return (
    <div className="w-full gap-3 flex text-xs">
      <span className="text-xs max-w-[6rem] truncate">{option.label}</span>
      <div className="flex ml-auto gap-2 justify-end">
        {option?.value !== '-1' ? (
          <>
            <SvgEdit onMouseDown={(e) => handleEdit(e, option)} />
            <SvgDelete onMouseDown={(e) => handleDelete(e, option)} />
          </>
        ) : null}
      </div>
    </div>
  )
}

export default TableViewOptionBox
